import { render, staticRenderFns } from "./project-config-form.vue?vue&type=template&id=1bc0913e&scoped=true"
import script from "./project-config-form.vue?vue&type=script&setup=true&lang=js"
export * from "./project-config-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./project-config-form.vue?vue&type=style&index=0&id=1bc0913e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0913e",
  null
  
)

export default component.exports